"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CriteriaRows_1 = __importDefault(require("@Components/Search/SearchWithCriteria/CriteriaRows"));
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const mobx_react_1 = require("mobx-react");
const clsx_1 = __importDefault(require("clsx"));
const SearchCriteriaSection = (props) => {
    const { searchCriteriaStore, canAddCriteria, orientation, isUniqueTooltip, disableAutoComplete } = props;
    const { formState } = (0, react_hook_form_1.useFormContext)();
    const { fields, replace } = (0, react_hook_form_1.useFieldArray)({
        name: 'search',
        keyName: 'fieldId',
    });
    // Sync criterion values back to the store
    const watch = (0, react_hook_form_1.useWatch)({ name: 'search' });
    (0, react_1.useEffect)(() => {
        if (formState.isDirty) {
            searchCriteriaStore.syncFormValues(watch);
        }
    }, [formState.isDirty, watch, searchCriteriaStore]);
    const renderCriteria = () => {
        replace(searchCriteriaStore.searchCriteria);
    };
    (0, react_1.useEffect)(renderCriteria, [searchCriteriaStore.searchCriteria]);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(orientation === 'row' && 'search-side-by-side') },
        react_1.default.createElement(CriteriaRows_1.default, { searchCriteriaStore: searchCriteriaStore, fields: fields, disableAutoComplete: disableAutoComplete }),
        canAddCriteria && (react_1.default.createElement(Button_1.Button, { mainColor: true, className: "add-criteria-button", type: "secondary", submitType: 'button', icon: common_1.ICONS.add, disabled: searchCriteriaStore.isAddCriterionDisabled, onClick: () => searchCriteriaStore.addCriterion() },
            searchCriteriaStore.atMaxCriteria ? 'Max Criteria Reached' : 'Add Criteria',
            searchCriteriaStore.isUniqueSelected && isUniqueTooltip))));
};
exports.default = (0, mobx_react_1.observer)(SearchCriteriaSection);
